var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-view page-deploy"},[_c('div',{staticClass:"page-header"},[_c('span',{staticClass:"header-text"},[_vm._v(_vm._s(_vm.wayName))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route-show-view"},[_c('div',{attrs:{"id":"fengMap"}})])
}]

export { render, staticRenderFns }